import Point from "./point.js"

class labelPoint extends Point{
  constructor(obj){
    super(obj)

    const { content, fontSize, fontStyleC, fontSizeHL, fontStyleHLC } = obj

    this._highlightOptions = {
      ...this._highlightOptions,
      font_size: fontSizeHL !== null ? fontSizeHL : 1.0,
      font_family: fontStyleHLC ? fontStyleHLC : '宋体'
    }
    this._styleOptions = {
      ...this._styleOptions,
      text: content ? `{${content}}` : 'label',
      font_size: fontSize !== null ? fontSize : 100.0,
      font_family: fontStyleC ? fontStyleC : '宋体',
      horizontalOrigin: this.getHorizontal(),
      verticalOrigin: this.getVertical(),
      highlight: this._highlight ? this._highlightOptions : {},
    }
    this._symbol = {
      ...this._symbol,
      type: 'labelP',
      styleOptions: this._styleOptions
    }
    this._initObj = {
      ...this._initObj,
      symbol: this._symbol
    }
  }

  getHorizontal(horizontal){
    if(horizontal){
      switch(horizontal){
        case 'centerH':
          return Cesium.HorizontalOrigin.CENTER
        case 'left':
          return Cesium.HorizontalOrigin.LEFT
        case 'right':
          return Cesium.HorizontalOrigin.RIGHT
      }
    }
  }

  getVertical(vertical){
    if(vertical){
      switch(vertical){
        case 'centerV':
          return Cesium.VerticalOrigin.CENTER
        case 'top':
          return Cesium.VerticalOrigin.TOP
        case 'bottom':
          return Cesium.VerticalOrigin.BOTTOM
      }
    }
  }
}

export default labelPoint